// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"bf54a971","308":"6ab24d52","316":"e2d2dc9b","859":"d000636f","941":"1ba855d4"}[chunkId] + ".chunk.js";
};